import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailOffice/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailMobile/img/1.avif';
import image2 from '@src/assets/images/solution/retailMobile/img/2.avif';
import image3 from '@src/assets/images/solution/retailMobile/img/3.avif';
import image4 from '@src/assets/images/solution/retailMobile/img/4.avif';
import image5 from '@src/assets/images/solution/retailMobile/img/5.avif';
import image6 from '@src/assets/images/solution/retailMobile/img/6.avif';
import image7 from '@src/assets/images/solution/retailMobile/img/7.avif';
import image8 from '@src/assets/images/solution/retailMobile/img/8.avif';
import { recommendationEdge, recommendationSwitch, retailMobile1, retailMobile2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: 'リテールソリューション',
  banner: {
    title: 'スマートフォン体験は自由に、展示のセキュリティは自動で管理',
    desc: 'ワイヤレスタグ技術により、スマートフォンを自由に体験しながら展示のセキュリティを自動で維持します。',
  },

  recommend: {
    title: '',
    desc: 'ORBRO OS はリアルタイム位置追跡とスマートモニタリングのための強力なプラットフォームです。<br/>BLE、UWB、AIベースの映像分析技術と完全に統合され、安全性・効率性・拡張性を実現します。',
    labels: {
      desktop: [
        { img: retailMobile1, data: recommendation.safeTag },
        { img: retailMobile2, data: recommendation.safeCradle },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.safeTag }, { data: recommendation.safeCradle }, { data: recommendation.edgeRtls }, { data: recommendation.switch }],
    },
  },

  func: [
    {
      theme: '顧客の体験フローに合わせたスマート展示環境を構築',
      title: '自由に体験できるモバイルストア',
      desc: 'お客様はスマートフォンを自由に手に取り、操作してリアルな体験が可能です。ワイヤーなしでもセキュリティを維持できる設計で、制限なくご利用いただけます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度提供',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: 'サイネージ連動で情報表示',
      desc: '端末を持ち上げると、製品情報が自動でサイネージに表示されます。案内がなくても主な機能を自然に確認でき、スタッフがいなくても体験と情報提供が両立できます。',
      sub1: 'リアルタイム状況把握',
      icon1: IconClockGray,
      sub2: '迅速なデータ連携',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '離脱検知による管理者通知',
      desc: '端末が指定された場所を離れると、タグからアラームが鳴り、管理者に通知が送信されます。自由な体験を妨げずに即時対応が可能です。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドへのデータ保存',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '体験データから人気端末を分析',
      desc: '端末のピックアップ回数や機能比較の利用履歴が自動で保存されます。データ分析により人気モデルを把握し、製品配置やマーケティング戦略に活用できます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドへのデータ保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: '展示用の専用タグとクレードルをご紹介',
      title: '自由な体験を可能にするワイヤレスタグ',
      desc: 'Safe Tag は端末に貼り付けて電源を供給し、位置追跡が可能な専用タグです。ワイヤー不要でもセキュリティを保ち、自由な体験が可能です。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドへのデータ保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '全てのスマートフォンに対応する汎用設計',
      desc: 'Safe Tag はメーカーや機種に関係なく、ほとんどのスマートフォンに取り付け可能な設計です。統一された展示ができ、運用効率が向上します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドへのデータ保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '展示とセキュリティを両立するクレードル',
      desc: 'クレードルはタグと精密に連動し、安定した電源供給とリアルタイムの位置検知を可能にします。ワイヤレス充電と移動管理を同時に行えます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドへのデータ保存',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '自然な設置を実現する15度ドッキング設計',
      desc: 'クレードルは15度の角度で設計されており、端末を自然に持ち上げたり戻したりできます。体験が繰り返されても安定した位置での設置が可能です。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドへのデータ保存',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '機能概要',
    desc: '在庫管理の効率化、時間とコストの削減、透明性と追跡性の向上など、多くの利点があります。<br/>最適な作業環境と高効率を実現するため、ORBROは以下の機能も提供しています。',
    data: [
      {
        icon: IconLayers,
        title: 'ワイヤレスタグ展示構造',
        desc: '展示対象にタグを取り付け、ワイヤレスで位置を追跡し状態をモニタリングします。',
      },
      {
        icon: IconLocation,
        title: '距離検知によるセキュリティ',
        desc: 'タグとデバイスの距離が離れると、セキュリティエリアを離脱したと判断し警報を発します。',
      },
      {
        icon: IconSearch,
        title: '一体型タグ設計',
        desc: 'デバイス下部にタグをすっきりと密着させ、展示物の外観を損なわずに設置できます。',
      },
      {
        icon: IconAnalytics,
        title: '離脱検知による通知機能',
        desc: '指定位置を離れるとタグが警報を発し、管理者へ通知を送信します。',
      },
      {
        icon: IconChartBar,
        title: 'リアルタイム位置追跡と電源供給',
        desc: '展示中も電源を供給しながらリアルタイムで位置追跡が可能です。',
      },
      {
        icon: IconRoute,
        title: 'スライドヒンジ構造',
        desc: '充電端子の位置に合わせて柔軟にタグを動かし、様々なデバイスに対応可能です。',
      },
      {
        icon: IconRoute,
        title: '15度のドッキング角度設計',
        desc: '自然に持ち上げて戻せるように設計された人間工学的な角度を提供します。',
      },
      {
        icon: IconLayers,
        title: 'ワイヤレス充電対応展示環境',
        desc: 'クレードルとタグは外部に露出せず、展示環境の美観を保ちながら安定した電源を供給します。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'logisticsAsset' }, { data: 'manufacturingSteel' }, { data: 'blogOffice' }, { data: 'blogRTLS' }],
};
